import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { object, string } from "yup";

import { AustraliaLicenceInputField } from "./AustraliaLicenceInputField";
import { AustraliaLicenceSummaryField } from "./AustraliaLicenceSummaryField";
import { FieldType } from "../types";

export function AustraliaLicenceField(
  field: components["schemas"]["AustraliaLicenceCheckField"]
): FieldType<components["schemas"]["AustraliaLicenceCheckField"]> {
  return {
    field,
    inputElement: <AustraliaLicenceInputField key={field.name} field={field} />,
    summaryElement: () => (
      <AustraliaLicenceSummaryField key={field.name} field={field} />
    ),
    initialValue: field.value,
    schema: australiaLicenceSchema,
  };
}

export const australiaLicenceSchema = object()
  .nullable()
  .shape({
    number: string().required().label(t("Number")),
    issuing_state_province_or_territory: string()
      .required()
      .label(t("Issuing state or territory")),
  });
